import _asyncToGenerator from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/jove-dashboard/node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js";
import { api } from '.';
export function getCountriesByISO(_x) {
  return _getCountriesByISO.apply(this, arguments);
}

function _getCountriesByISO() {
  _getCountriesByISO = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(countries) {
    var queryParams, res;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            queryParams = new URLSearchParams();
            queryParams.append('limit', '100');
            queryParams.append('offset', '0');
            queryParams.append('order', 'name');
            countries.forEach(function (country) {
              queryParams.append('codes', country);
            });
            _context.next = 8;
            return api.get("/country?".concat(queryParams.toString()));

          case 8:
            res = _context.sent;

            if (res !== null && res !== void 0 && res.data) {
              _context.next = 11;
              break;
            }

            throw new Error('No data returned when getting promotions');

          case 11:
            return _context.abrupt("return", {
              data: res.data.data,
              total_count: res.data.total_count
            });

          case 14:
            _context.prev = 14;
            _context.t0 = _context["catch"](0);
            console.error('Error getting promotions', _context.t0);
            return _context.abrupt("return", {
              data: [],
              total_count: 0
            });

          case 18:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 14]]);
  }));
  return _getCountriesByISO.apply(this, arguments);
}